// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile Responsive Styles for Dashboard */

/* Mobile breakpoints */
@media (max-width: 768px) {
  /* Hide desktop sidebar completely on mobile */
  .sidebar-desktop {
    display: none !important;
  }

  /* Bottom Navigation Bar for Mobile */
  .mobile-bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 70px;
    background: var(--surface-color);
    border-top: 1px solid var(--border-color);
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 1001;
    padding: 8px 8px calc(8px + env(safe-area-inset-bottom));
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }

  .mobile-bottom-nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    flex: 1;
    padding: 8px 4px;
    border-radius: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    max-width: 80px;
  }

  .mobile-bottom-nav-item.active {
    background: var(--surface-elev);
  }

  .mobile-bottom-nav-item svg {
    opacity: 0.7;
  }

  .mobile-bottom-nav-item.active svg {
    opacity: 1;
  }

  .mobile-bottom-nav-label {
    font-size: 10px;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  /* Adjust main content area for mobile */
  .dashboard-content {
    margin-left: 0 !important;
    margin-bottom: 80px !important; /* Space for bottom nav */
    padding-top: 140px !important; /* Space for fixed header to prevent content overflow */
    padding-bottom: calc(20px + env(safe-area-inset-bottom)) !important;
  }

  /* Dashboard Header adjustments for mobile */
  .dashboard-header {
    left: 0 !important;
    right: 0 !important;
    padding: 12px 16px !important;
  }

  .dashboard-header-content {
    flex-direction: column !important;
    gap: 12px !important;
    align-items: flex-start !important;
  }

  .dashboard-header-title {
    font-size: 18px !important;
  }

  .dashboard-header-description {
    font-size: 12px !important;
  }

  .dashboard-header-actions {
    flex-wrap: wrap !important;
    gap: 6px !important;
    width: 100%;
  }

  .dashboard-header-action-button {
    padding: 6px 10px !important;
  }

  .dashboard-header-user {
    display: none !important; /* Hide user info on very small screens */
  }

  /* KPI Cards responsive */
  .kpi-card {
    min-width: 140px !important;
    padding: 16px 12px !important;
  }

  .kpi-card-title {
    font-size: 11px !important;
  }

  .kpi-card-value {
    font-size: 20px !important;
  }

  /* Charts responsive */
  .chart-container {
    min-height: 250px !important;
    overflow-x: auto;
  }

  /* Tables responsive */
  .data-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .data-table {
    min-width: 600px;
  }

  .data-table th,
  .data-table td {
    padding: 8px 6px !important;
    font-size: 12px !important;
  }

  /* Cards and widgets */
  .animated-card {
    padding: 16px !important;
    margin: 12px 0 !important;
  }

  .widget-container {
    padding: 16px !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  /* Grid layouts become single column */
  .grid-layout {
    grid-template-columns: 1fr !important;
  }

  /* Flexbox responsive */
  .flex-wrap-mobile {
    flex-direction: column !important;
  }

  /* Button groups */
  .button-group {
    flex-wrap: wrap !important;
    gap: 6px !important;
  }

  .button-group button {
    font-size: 12px !important;
    padding: 6px 10px !important;
  }

  /* Select dropdowns */
  select,
  .searchable-select {
    width: 100% !important;
    font-size: 14px !important;
  }

  /* Modals */
  .modal-content {
    margin: 20px;
    max-width: calc(100% - 40px) !important;
    max-height: calc(100vh - 40px);
    overflow-y: auto;
  }

  /* Scatter plots and complex charts */
  .recharts-surface {
    overflow: visible;
  }

  /* Period selector buttons */
  .period-selector {
    flex-wrap: wrap !important;
    gap: 6px !important;
  }

  .period-button {
    padding: 6px 12px !important;
    font-size: 12px !important;
  }

  /* Filter panels */
  .filter-panel {
    padding: 12px !important;
  }

  .filter-panel-row {
    flex-direction: column !important;
    gap: 12px !important;
  }

  /* Performance attribution tables */
  .performance-table {
    font-size: 11px !important;
  }

  .performance-table th,
  .performance-table td {
    padding: 6px 4px !important;
  }

  /* Top/Worst contributors */
  .contributors-container {
    flex-direction: column !important;
  }

  .contributor-section {
    width: 100% !important;
    min-width: unset !important;
  }

  /* Aggregations page specific */
  .dimension-selector {
    flex-direction: column !important;
    gap: 12px !important;
  }

  .dimension-selector > div {
    width: 100% !important;
    min-width: unset !important;
  }

  /* Waterfall chart */
  .waterfall-chart {
    min-height: 300px;
  }

  /* Custom inputs grid */
  .custom-inputs-grid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }

  /* Metric boxes */
  .metric-box-grid {
    grid-template-columns: 1fr 1fr !important;
  }

  /* Universe page instrument selector */
  .instrument-selector {
    width: 100% !important;
  }

  /* AI Agent Bubble - adjust position for mobile nav */
  .ai-agent-bubble {
    bottom: 85px !important; /* Above bottom nav */
    right: 16px !important;
  }

  /* Scrollable horizontal content */
  .scroll-x-mobile {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Hide labels on very small screens */
  @media (max-width: 380px) {
    .mobile-bottom-nav-label {
      display: none;
    }

    .mobile-bottom-nav {
      height: 60px;
    }

    .mobile-bottom-nav-item {
      padding: 4px;
    }
  }
}

/* Tablet adjustments (768px - 1024px) */
@media (min-width: 769px) and (max-width: 1024px) {
  .dashboard-content {
    margin-left: 80px !important; /* Collapsed sidebar */
  }

  .dashboard-header {
    left: 80px !important;
  }

  .grid-layout {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)) !important;
  }

  .kpi-card {
    min-width: 180px !important;
  }

  .metric-box-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

/* Small mobile (max-width: 480px) */
@media (max-width: 480px) {
  .dashboard-content {
    padding-top: 130px !important; /* Adjust for smaller header on small screens */
  }

  .dashboard-header {
    padding: 10px 12px !important;
  }

  .dashboard-header-title {
    font-size: 16px !important;
  }

  .dashboard-header-description {
    font-size: 11px !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .kpi-card-value {
    font-size: 18px !important;
  }

  .animated-card {
    padding: 12px !important;
  }

  h1, .h1-text {
    font-size: 20px !important;
  }

  h2, .h2-text {
    font-size: 18px !important;
  }

  h3, .h3-text {
    font-size: 16px !important;
  }

  h4, .h4-text {
    font-size: 14px !important;
  }
}

/* Safe area insets for notched devices */
@supports (padding: max(0px)) {
  .mobile-bottom-nav {
    padding-bottom: max(8px, env(safe-area-inset-bottom));
  }

  .dashboard-content {
    padding-bottom: max(20px, calc(20px + env(safe-area-inset-bottom)));
  }
}

/* Landscape mobile adjustments */
@media (max-width: 812px) and (orientation: landscape) {
  .mobile-bottom-nav {
    height: 50px;
    padding: 4px 8px;
  }

  .mobile-bottom-nav-item {
    padding: 4px 2px;
    gap: 2px;
  }

  .mobile-bottom-nav-label {
    font-size: 9px;
  }

  .dashboard-content {
    margin-bottom: 60px !important;
  }

  .ai-agent-bubble {
    bottom: 65px !important;
  }
}

/* Dark mode specific adjustments */
body:not(.light-theme) {
  --surface-color: #0d131a;
  --surface-elev: #1a2332;
  --surface-card: #222d3d;
  --border-color: #2a3544;
}

body.light-theme {
  --surface-color: #ffffff;
  --surface-elev: #f5f7fa;
  --surface-card: #fafbfc;
  --border-color: #e5e7eb;
}

/* Touch-friendly sizing for interactive elements */
@media (max-width: 768px) {
  button,
  .touchable {
    min-height: 44px;
    min-width: 44px;
  }

  input,
  select,
  textarea {
    min-height: 44px;
    font-size: 16px !important; /* Prevent zoom on iOS */
  }
}
`, "",{"version":3,"sources":["webpack://./src/mobile-responsive.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,uBAAuB;AACvB;EACE,8CAA8C;EAC9C;IACE,wBAAwB;EAC1B;;EAEA,qCAAqC;EACrC;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,gCAAgC;IAChC,yCAAyC;IACzC,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,wDAAwD;IACxD,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,yBAAyB;IACzB,8BAA8B,EAAE,yBAAyB;IACzD,6BAA6B,EAAE,uDAAuD;IACtF,mEAAmE;EACrE;;EAEA,4CAA4C;EAC5C;IACE,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;IACjC,oBAAoB;IACpB,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB,EAAE,yCAAyC;EACrE;;EAEA,yBAAyB;EACzB;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,sBAAsB;EACtB;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,sBAAsB;EACtB;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA,sCAAsC;EACtC;IACE,qCAAqC;EACvC;;EAEA,uBAAuB;EACvB;IACE,iCAAiC;EACnC;;EAEA,kBAAkB;EAClB;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA,qBAAqB;EACrB;;IAEE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA,WAAW;EACX;IACE,YAAY;IACZ,uCAAuC;IACvC,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA,qCAAqC;EACrC;IACE,iBAAiB;EACnB;;EAEA,4BAA4B;EAC5B;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA,kBAAkB;EAClB;IACE,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA,mCAAmC;EACnC;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA,2BAA2B;EAC3B;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA,+BAA+B;EAC/B;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA,oBAAoB;EACpB;IACE,iBAAiB;EACnB;;EAEA,uBAAuB;EACvB;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA,iBAAiB;EACjB;IACE,yCAAyC;EAC3C;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;EACxB;;EAEA,qDAAqD;EACrD;IACE,uBAAuB,EAAE,qBAAqB;IAC9C,sBAAsB;EACxB;;EAEA,kCAAkC;EAClC;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,sCAAsC;EACtC;IACE;MACE,aAAa;IACf;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,YAAY;IACd;EACF;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,4BAA4B,EAAE,sBAAsB;EACtD;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sEAAsE;EACxE;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,6BAA6B,EAAE,+CAA+C;EAChF;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,qDAAqD;EACvD;;EAEA;IACE,mEAAmE;EACrE;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;IAChB,0BAA0B,EAAE,wBAAwB;EACtD;AACF","sourcesContent":["/* Mobile Responsive Styles for Dashboard */\r\n\r\n/* Mobile breakpoints */\r\n@media (max-width: 768px) {\r\n  /* Hide desktop sidebar completely on mobile */\r\n  .sidebar-desktop {\r\n    display: none !important;\r\n  }\r\n\r\n  /* Bottom Navigation Bar for Mobile */\r\n  .mobile-bottom-nav {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 70px;\r\n    background: var(--surface-color);\r\n    border-top: 1px solid var(--border-color);\r\n    display: flex;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    z-index: 1001;\r\n    padding: 8px 8px calc(8px + env(safe-area-inset-bottom));\r\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .mobile-bottom-nav-item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 4px;\r\n    flex: 1;\r\n    padding: 8px 4px;\r\n    border-radius: 8px;\r\n    transition: all 0.3s ease;\r\n    cursor: pointer;\r\n    max-width: 80px;\r\n  }\r\n\r\n  .mobile-bottom-nav-item.active {\r\n    background: var(--surface-elev);\r\n  }\r\n\r\n  .mobile-bottom-nav-item svg {\r\n    opacity: 0.7;\r\n  }\r\n\r\n  .mobile-bottom-nav-item.active svg {\r\n    opacity: 1;\r\n  }\r\n\r\n  .mobile-bottom-nav-label {\r\n    font-size: 10px;\r\n    font-weight: 500;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 100%;\r\n  }\r\n\r\n  /* Adjust main content area for mobile */\r\n  .dashboard-content {\r\n    margin-left: 0 !important;\r\n    margin-bottom: 80px !important; /* Space for bottom nav */\r\n    padding-top: 140px !important; /* Space for fixed header to prevent content overflow */\r\n    padding-bottom: calc(20px + env(safe-area-inset-bottom)) !important;\r\n  }\r\n\r\n  /* Dashboard Header adjustments for mobile */\r\n  .dashboard-header {\r\n    left: 0 !important;\r\n    right: 0 !important;\r\n    padding: 12px 16px !important;\r\n  }\r\n\r\n  .dashboard-header-content {\r\n    flex-direction: column !important;\r\n    gap: 12px !important;\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n  .dashboard-header-title {\r\n    font-size: 18px !important;\r\n  }\r\n\r\n  .dashboard-header-description {\r\n    font-size: 12px !important;\r\n  }\r\n\r\n  .dashboard-header-actions {\r\n    flex-wrap: wrap !important;\r\n    gap: 6px !important;\r\n    width: 100%;\r\n  }\r\n\r\n  .dashboard-header-action-button {\r\n    padding: 6px 10px !important;\r\n  }\r\n\r\n  .dashboard-header-user {\r\n    display: none !important; /* Hide user info on very small screens */\r\n  }\r\n\r\n  /* KPI Cards responsive */\r\n  .kpi-card {\r\n    min-width: 140px !important;\r\n    padding: 16px 12px !important;\r\n  }\r\n\r\n  .kpi-card-title {\r\n    font-size: 11px !important;\r\n  }\r\n\r\n  .kpi-card-value {\r\n    font-size: 20px !important;\r\n  }\r\n\r\n  /* Charts responsive */\r\n  .chart-container {\r\n    min-height: 250px !important;\r\n    overflow-x: auto;\r\n  }\r\n\r\n  /* Tables responsive */\r\n  .data-table-container {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .data-table {\r\n    min-width: 600px;\r\n  }\r\n\r\n  .data-table th,\r\n  .data-table td {\r\n    padding: 8px 6px !important;\r\n    font-size: 12px !important;\r\n  }\r\n\r\n  /* Cards and widgets */\r\n  .animated-card {\r\n    padding: 16px !important;\r\n    margin: 12px 0 !important;\r\n  }\r\n\r\n  .widget-container {\r\n    padding: 16px !important;\r\n    overflow-x: auto !important;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  /* Grid layouts become single column */\r\n  .grid-layout {\r\n    grid-template-columns: 1fr !important;\r\n  }\r\n\r\n  /* Flexbox responsive */\r\n  .flex-wrap-mobile {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  /* Button groups */\r\n  .button-group {\r\n    flex-wrap: wrap !important;\r\n    gap: 6px !important;\r\n  }\r\n\r\n  .button-group button {\r\n    font-size: 12px !important;\r\n    padding: 6px 10px !important;\r\n  }\r\n\r\n  /* Select dropdowns */\r\n  select,\r\n  .searchable-select {\r\n    width: 100% !important;\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  /* Modals */\r\n  .modal-content {\r\n    margin: 20px;\r\n    max-width: calc(100% - 40px) !important;\r\n    max-height: calc(100vh - 40px);\r\n    overflow-y: auto;\r\n  }\r\n\r\n  /* Scatter plots and complex charts */\r\n  .recharts-surface {\r\n    overflow: visible;\r\n  }\r\n\r\n  /* Period selector buttons */\r\n  .period-selector {\r\n    flex-wrap: wrap !important;\r\n    gap: 6px !important;\r\n  }\r\n\r\n  .period-button {\r\n    padding: 6px 12px !important;\r\n    font-size: 12px !important;\r\n  }\r\n\r\n  /* Filter panels */\r\n  .filter-panel {\r\n    padding: 12px !important;\r\n  }\r\n\r\n  .filter-panel-row {\r\n    flex-direction: column !important;\r\n    gap: 12px !important;\r\n  }\r\n\r\n  /* Performance attribution tables */\r\n  .performance-table {\r\n    font-size: 11px !important;\r\n  }\r\n\r\n  .performance-table th,\r\n  .performance-table td {\r\n    padding: 6px 4px !important;\r\n  }\r\n\r\n  /* Top/Worst contributors */\r\n  .contributors-container {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  .contributor-section {\r\n    width: 100% !important;\r\n    min-width: unset !important;\r\n  }\r\n\r\n  /* Aggregations page specific */\r\n  .dimension-selector {\r\n    flex-direction: column !important;\r\n    gap: 12px !important;\r\n  }\r\n\r\n  .dimension-selector > div {\r\n    width: 100% !important;\r\n    min-width: unset !important;\r\n  }\r\n\r\n  /* Waterfall chart */\r\n  .waterfall-chart {\r\n    min-height: 300px;\r\n  }\r\n\r\n  /* Custom inputs grid */\r\n  .custom-inputs-grid {\r\n    grid-template-columns: 1fr !important;\r\n    gap: 12px !important;\r\n  }\r\n\r\n  /* Metric boxes */\r\n  .metric-box-grid {\r\n    grid-template-columns: 1fr 1fr !important;\r\n  }\r\n\r\n  /* Universe page instrument selector */\r\n  .instrument-selector {\r\n    width: 100% !important;\r\n  }\r\n\r\n  /* AI Agent Bubble - adjust position for mobile nav */\r\n  .ai-agent-bubble {\r\n    bottom: 85px !important; /* Above bottom nav */\r\n    right: 16px !important;\r\n  }\r\n\r\n  /* Scrollable horizontal content */\r\n  .scroll-x-mobile {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  /* Hide labels on very small screens */\r\n  @media (max-width: 380px) {\r\n    .mobile-bottom-nav-label {\r\n      display: none;\r\n    }\r\n\r\n    .mobile-bottom-nav {\r\n      height: 60px;\r\n    }\r\n\r\n    .mobile-bottom-nav-item {\r\n      padding: 4px;\r\n    }\r\n  }\r\n}\r\n\r\n/* Tablet adjustments (768px - 1024px) */\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .dashboard-content {\r\n    margin-left: 80px !important; /* Collapsed sidebar */\r\n  }\r\n\r\n  .dashboard-header {\r\n    left: 80px !important;\r\n  }\r\n\r\n  .grid-layout {\r\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)) !important;\r\n  }\r\n\r\n  .kpi-card {\r\n    min-width: 180px !important;\r\n  }\r\n\r\n  .metric-box-grid {\r\n    grid-template-columns: repeat(2, 1fr) !important;\r\n  }\r\n}\r\n\r\n/* Small mobile (max-width: 480px) */\r\n@media (max-width: 480px) {\r\n  .dashboard-content {\r\n    padding-top: 130px !important; /* Adjust for smaller header on small screens */\r\n  }\r\n\r\n  .dashboard-header {\r\n    padding: 10px 12px !important;\r\n  }\r\n\r\n  .dashboard-header-title {\r\n    font-size: 16px !important;\r\n  }\r\n\r\n  .dashboard-header-description {\r\n    font-size: 11px !important;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .kpi-card-value {\r\n    font-size: 18px !important;\r\n  }\r\n\r\n  .animated-card {\r\n    padding: 12px !important;\r\n  }\r\n\r\n  h1, .h1-text {\r\n    font-size: 20px !important;\r\n  }\r\n\r\n  h2, .h2-text {\r\n    font-size: 18px !important;\r\n  }\r\n\r\n  h3, .h3-text {\r\n    font-size: 16px !important;\r\n  }\r\n\r\n  h4, .h4-text {\r\n    font-size: 14px !important;\r\n  }\r\n}\r\n\r\n/* Safe area insets for notched devices */\r\n@supports (padding: max(0px)) {\r\n  .mobile-bottom-nav {\r\n    padding-bottom: max(8px, env(safe-area-inset-bottom));\r\n  }\r\n\r\n  .dashboard-content {\r\n    padding-bottom: max(20px, calc(20px + env(safe-area-inset-bottom)));\r\n  }\r\n}\r\n\r\n/* Landscape mobile adjustments */\r\n@media (max-width: 812px) and (orientation: landscape) {\r\n  .mobile-bottom-nav {\r\n    height: 50px;\r\n    padding: 4px 8px;\r\n  }\r\n\r\n  .mobile-bottom-nav-item {\r\n    padding: 4px 2px;\r\n    gap: 2px;\r\n  }\r\n\r\n  .mobile-bottom-nav-label {\r\n    font-size: 9px;\r\n  }\r\n\r\n  .dashboard-content {\r\n    margin-bottom: 60px !important;\r\n  }\r\n\r\n  .ai-agent-bubble {\r\n    bottom: 65px !important;\r\n  }\r\n}\r\n\r\n/* Dark mode specific adjustments */\r\nbody:not(.light-theme) {\r\n  --surface-color: #0d131a;\r\n  --surface-elev: #1a2332;\r\n  --surface-card: #222d3d;\r\n  --border-color: #2a3544;\r\n}\r\n\r\nbody.light-theme {\r\n  --surface-color: #ffffff;\r\n  --surface-elev: #f5f7fa;\r\n  --surface-card: #fafbfc;\r\n  --border-color: #e5e7eb;\r\n}\r\n\r\n/* Touch-friendly sizing for interactive elements */\r\n@media (max-width: 768px) {\r\n  button,\r\n  .touchable {\r\n    min-height: 44px;\r\n    min-width: 44px;\r\n  }\r\n\r\n  input,\r\n  select,\r\n  textarea {\r\n    min-height: 44px;\r\n    font-size: 16px !important; /* Prevent zoom on iOS */\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
